class notifymeForm extends HTMLElement {
  constructor() {
    super();
    this.formEl = this.querySelector('form');
    this.name = this.querySelector('input[name="contact[name]"]').value;
    this.email = this.querySelector('input[name="contact[email]"]').value;
    this.phone = this.querySelector('input[name="contact[country]"]').value;
    this.button = this.querySelector('button[type="submit"]');
    this.sendUrl = this.formEl.getAttribute('action');
    this.successMessageEl = this.querySelector('.success-message');
    this.alredyErrorMessageEl = this.querySelector('.already-error-message');
    this.ErrorMessageEl = this.querySelector('.error-message');

    this.formEl.addEventListener('submit', this.onClickHandler.bind(this));
  }

  onClickHandler(event) {
    event.preventDefault();
    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');

    const data = new FormData(event.target);
    const value = Object.fromEntries(data.entries());

    this.postData(value)
  }

  async postData(data) {
    console.log(JSON.stringify(data));
    const response = await fetch(this.sendUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(data)
    });
    let outcome = await response.json();
    this.handleResponse(outcome);
  }

  handleResponse(response) {
    if (response.success === 'Data processed successfully') {
      this.button.classList.remove('loading')
      this.button.removeAttribute('disabled');
      this.formEl.classList.add('hidden');
      this.successMessageEl.classList.remove('hidden');
    } else if (response.error === '"User already registered for this product"') {
      this.button.classList.remove('loading')
      this.button.removeAttribute('disabled');
      this.formEl.classList.add('hidden');
      this.alredyErrorMessageEl.classList.remove('hidden');
    } else {
      this.button.classList.remove('loading')
      this.button.removeAttribute('disabled');
      this.formEl.classList.add('hidden');
      this.ErrorMessageEl.classList.remove('hidden');
    }
  }
}

customElements.define('notifyme-form', notifymeForm);